import { curry } from 'ramda';

const getValueAtKey = curry((key, option) => option[key]);

export const buildOption = (value) => ({ label: value, value });

const optionsFromGroups = (optionGroups) =>
  optionGroups.reduce(
    (denormalizedOptions, optionGroup) => [
      ...denormalizedOptions,
      ...optionGroup.options
    ],
    []
  );

export const getOptionValue = getValueAtKey('value');
export const getOptionLabel = getValueAtKey('label');

export const findOptionFrom = (options = [], { label, value } = {}) =>
  options.find((option) => option.label === label || option.value === value);

export const hasOptionShape = (item = {}) =>
  Boolean(item && typeof item === 'object' && item.label && item.value);

export const hasOptionGroupShape = (item = {}) =>
  Boolean(item && typeof item === 'object' && item.label && item.options);

export const findOrBuildOption = (options, value) => {
  if (hasOptionShape(value)) {
    return value;
  }

  if (hasOptionGroupShape(options[0])) {
    return (
      findOptionFrom(optionsFromGroups(options), { value }) ||
      buildOption(value)
    );
  }

  return findOptionFrom(options, { value }) || buildOption(value);
};

// useful as a mapping function with point-free style
export const findOrBuildOptionFrom = curry(findOrBuildOption);
